import { Fragment, useEffect, useState } from "react";
import ModalDialog from "../../components/modalDialog/ModalDialog";
import ModalDialogContent from "../../components/modalDialog/modalDialogContent/ModalDialogContent";
import ModalDialogButtons from "../../components/modalDialog/modalDialogButtons/ModalDialogButtons";
import "./ReportShareOptionsDialog.css";
import { GetCampaignReportSummaryOptions, UpdateCampaignReportSummaryOptions } from "../../Services";
import { toast } from "react-toastify";

const ReportShareOptionsDialog = ({ campaignId, reportShortName, onSubmit, onCancel }) => {
    const [shareOptions, setShareOptions] = useState({ hideGrid: false, hideReviews: false, hideRank: false });

    useEffect(() => {
        getReportShareOptions();
    }, []);

    const getReportShareOptions = async () => {
        let response = await GetCampaignReportSummaryOptions(campaignId, reportShortName);

        if (response) {
            setShareOptions(response);
        }
    };

    const handleShareOptionsChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        let checked = e.target.checked;

        setShareOptions({
            ...shareOptions,
            [name]: e.target.type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async () => {
        let data = {
            reportShortName: reportShortName,
            optionsJson: JSON.stringify(shareOptions),
        };

        const response = await UpdateCampaignReportSummaryOptions(campaignId, data);

        if (response) {
            toast.success("Options saved successfully");

            if (onSubmit) {
                onSubmit();
            }
        } else {
            toast.error("Error");
        }
    };

    const handleCancel = async () => {
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <Fragment>
            <ModalDialog position="right-sidebar">
                <ModalDialogContent align="start">
                    <h4 className="mb-3">Share Options</h4>

                    <div className="row">
                        <div className="col-12 mb-2">
                            <label htmlFor="hideGrid" className="form-check-label">
                                Hide Business Profile Rank:
                            </label>
                            <input
                                type="checkbox"
                                className="form-check-input ms-3"
                                name="hideGrid"
                                checked={shareOptions ? shareOptions.hideGrid : false}
                                onChange={handleShareOptionsChange}
                            />
                        </div>
                        <div className="col-12 mb-2">
                            <label htmlFor="hideReviews" className="form-check-label">
                                Hide Reviews:
                            </label>
                            <input
                                type="checkbox"
                                className="form-check-input ms-3"
                                name="hideReviews"
                                checked={shareOptions ? shareOptions.hideReviews : false}
                                onChange={handleShareOptionsChange}
                            />
                        </div>
                        <div className="col-12 mb-2">
                            <label htmlFor="hideRank" className="form-check-label">
                                Hide Directory Pages Rank:
                            </label>
                            <input
                                type="checkbox"
                                className="form-check-input ms-3"
                                name="hideRank"
                                checked={shareOptions ? shareOptions.hideRank : false}
                                onChange={handleShareOptionsChange}
                            />
                        </div>
                    </div>
                </ModalDialogContent>
                <ModalDialogButtons>
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        Save
                    </button>
                    <button className="btn btn-outline-primary" onClick={handleCancel}>
                        Cancel
                    </button>
                </ModalDialogButtons>
            </ModalDialog>
        </Fragment>
    );
};

export default ReportShareOptionsDialog;
